export enum AuthResult {    
    Failure = 0,
    Success = 1,
    NeedsTwoFactorKey = 2,
    NeedsPasswordUpdate = 3
}